import { Navigate } from 'react-router-dom';
import { useParams } from '@/lib/navigation';
import ArticlesView from '@/components/help-center/ArticlesView';
import { GuidePageShell } from '@/components/help-center/GuidePageShell';
import { resolveGuideCategoryId } from '@/lib/guide-routes';

export default function GuideArticlePage() {
  const { category = '', slug = '' } = useParams<{ category: string; slug: string }>();
  const categoryId = resolveGuideCategoryId(category);
  if (!categoryId) return <Navigate to="/" replace />;

  return (
    <GuidePageShell>
      <ArticlesView category={categoryId} articleSlug={slug} />
    </GuidePageShell>
  );
}
